import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, Autocomplete } from '@mui/material';

export default function ClientSelect({
  name,
  rules,
  options,
  getOptionLabel,
  isOptionEqualToValue,
  read = false,
  freeSolo = false,
  onChangeCallback,
  ...rest
}) {
  const { control } = useFormContext();

  if (!freeSolo) {
    return (
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={null}
        render={({ field: { ref, ...field }, fieldState: { error, invalid } }) => {
          return (
            <Autocomplete
              {...field}
              fullWidth
              handleHomeEndKeys
              options={options}
              getOptionLabel={getOptionLabel}
              isOptionEqualToValue={isOptionEqualToValue}
              renderInput={(params) => (
                <TextField {...params} {...rest} inputRef={ref} error={invalid} helperText={error?.message} />
              )}
              onChange={(e, value) => {
                field.onChange(value);
                if (onChangeCallback) {
                  onChangeCallback(e, value);
                }
              }}
              {...rest}
            />
          );
        }}
      />
    );
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={null}
      render={({ field: { ref, ...field }, fieldState: { error, invalid } }) => {
        return (
          <Autocomplete
            {...field}
            fullWidth
            handleHomeEndKeys
            options={options}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={isOptionEqualToValue}
            renderInput={(params) => (
              <TextField {...params} {...rest} inputRef={ref} error={invalid} helperText={error?.message} />
            )}
            onChange={(e, value) => field.onChange(value)}
            freeSolo
            onInputChange={(_, data) => {
              if (data) field.onChange(data);
            }}
            {...rest}
          />
        );
      }}
    />
  );
}
